import { PayloadAction, createSlice } from "@reduxjs/toolkit"

import { getSettings, setSetting } from "~/localsettings"
import { type ScoreLevel } from "~/SmartMatching/helpers"

type SmartMatchingState = {
  enabled: boolean
  selectedScoreLevels: ScoreLevel[]
}

const getInitialState = (): SmartMatchingState => ({
  enabled: getSettings().smartMatchingEnabled ?? false,
  selectedScoreLevels: getSettings().smartMatchingScoreLevels ?? [
    "great",
    "good",
  ],
})

const smartMatching = createSlice({
  name: "smartMatching",
  initialState: getInitialState(),
  reducers: {
    setSmartMatchingEnabled: (state, action: PayloadAction<boolean>) => {
      setSetting("smartMatchingEnabled", action.payload)
      state.enabled = action.payload
    },
    setSelectedScoreLevels: (state, action: PayloadAction<ScoreLevel[]>) => {
      setSetting("smartMatchingScoreLevels", action.payload)
      state.selectedScoreLevels = action.payload
    },
  },
})

export const { setSmartMatchingEnabled, setSelectedScoreLevels } =
  smartMatching.actions
export default smartMatching.reducer
